import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'

export default class extends Controller {
  static targets = [
    'drugCode', 'category',
    'genericCode', 'genericDisplay',
    'saltCode', 'saltDisplay',
    'strengthCode', 'strengthDisplay',
    'formCode', 'formDisplay',
    'unitCode', 'unitDisplay',
    'packageCode', 'packageDisplay',
    'quantity', 'unitPrice', 'totalPrice',
    'otherMedicine', 'othMedDrugGrouping'
  ]

  connect() {
    this.tomSelect = new TomSelect(this.drugCodeTarget, {
      allowEmptyOption: true,
      dropdownParent: 'body',
      onChange: () => this.syncFields()
    })
    requestAnimationFrame(() => this.initMutualExclusion())
  }

  disconnect() {
    this.tomSelect?.destroy()
  }

  calculateTotal() {
    const qty   = parseFloat(this.quantityTarget.value)  || 0
    const price = parseFloat(this.unitPriceTarget.value) || 0
    this.totalPriceTarget.value = (qty * price).toFixed(2)
  }

  otherMedicineInput() {
    if (this.otherMedicineTarget.value.trim()) {
      this.tomSelect.clear()
      this.tomSelect.disable()
    } else {
      this.tomSelect.enable()
    }
  }

  syncFields() {
    const value = this.tomSelect.getValue()
    const option = this.tomSelect.options[value]

    this.categoryTarget.value = option?.category || ''

    const fieldMap = [
      [this.genericCodeTarget,  this.genericDisplayTarget,  option?.genCode,      option?.genDisplay],
      [this.saltCodeTarget,     this.saltDisplayTarget,     option?.saltCode,     option?.saltDisplay],
      [this.strengthCodeTarget, this.strengthDisplayTarget, option?.strengthCode, option?.strengthDisplay],
      [this.formCodeTarget,     this.formDisplayTarget,     option?.formCode,     option?.formDisplay],
      [this.unitCodeTarget,     this.unitDisplayTarget,     option?.unitCode,     option?.unitDisplay],
      [this.packageCodeTarget,  this.packageDisplayTarget,  option?.packageCode,  option?.packageDisplay],
    ]

    for (const [codeTarget, displayTarget, code, display] of fieldMap) {
      codeTarget.value    = code    || ''
      displayTarget.value = display || ''
    }

    this.syncMutualExclusion()
  }

  initMutualExclusion() {
    if (this.tomSelect.getValue()) {
      this.setOtherMedsDisabled(true)
    } else if (this.otherMedicineTarget.value.trim()) {
      this.tomSelect.disable()
    }
  }

  syncMutualExclusion() {
    const hasDrug = !!this.tomSelect.getValue()
    if (hasDrug) {
      this.otherMedicineTarget.value = ''
      this.othMedGroupingTs?.clear()
    }
    this.setOtherMedsDisabled(hasDrug)
    if (!hasDrug && !this.otherMedicineTarget.value.trim()) this.tomSelect.enable()
  }

  setOtherMedsDisabled(disabled) {
    this.otherMedicineTarget.disabled = disabled
    disabled ? this.othMedGroupingTs?.disable() : this.othMedGroupingTs?.enable()
  }

  get othMedGroupingTs() {
    return this.application
      .getControllerForElementAndIdentifier(this.othMedDrugGroupingTarget, 'tom-select')
      ?.tomSelect
  }
}
